const handleStoreManager = (editor, selectedProject, selectedPage) => {

    const pageName = JSON.parse(localStorage.getItem('data'))[selectedProject].pages[selectedPage].name;
    const projectName = JSON.parse(localStorage.getItem('data'))[selectedProject].name;    
    editor.StorageManager.store({currentProject: projectName, currentPage: pageName});

}

export default handleStoreManager;
